module.exports = __webpack_public_path__ + "static/media/tulus-success-story-banner.e0b0b3a5.webp";